import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { formatPrice } from '@spotahome/soyuz-currency';

import { APPLY_ON_INCLUDED } from '../../constants/costs';

import { ListingCostsShape } from '../../constants/shapes';

import {
  getUnit,
  isCustomCost,
  isEstimatedCost
} from '../PaymentTimeline/costHelpers';

import DetailRow from './DetailRow';
import PaymentDetailsCard from './PaymentDetailsCard';

const BeforeMoveOut = ({ costs = {}, currencyCode, isCollapsed = true }) => {
  const costList = costs?.costs ?? [];

  const totalValue = formatPrice(costs.total, currencyCode);

  return (
    <PaymentDetailsCard
      dataTest="payment-details.before-move-out"
      headerValue={totalValue}
      isCollapsed={isCollapsed}
      title={trans('payment.details.before_move_out.title')}
    >
      {() =>
        costList.map(cost => {
          const unit = getUnit(cost.applyOn);
          const estimatedSubtitle = isEstimatedCost(cost.applyOn)
            ? trans('payment.timeline.estimated-cost')
            : null;
          const included = cost.applyOn === APPLY_ON_INCLUDED;
          const label =
            (isCustomCost(cost.type) ? cost.name : null) ??
            trans(`payment.timeline.cost.label.${cost.type}`);

          if (included) {
            return (
              <DetailRow
                key={cost.type}
                included
                label={label}
                tooltipText={cost.description || null}
                valueSubtitle={estimatedSubtitle}
              />
            );
          }

          const formattedBase = formatPrice(cost.value, currencyCode);
          const displayValue = unit
            ? trans(`price.per.${unit}`, { price: formattedBase })
            : formattedBase;

          return (
            <DetailRow
              key={cost.type}
              compareValueForStrike={
                typeof cost.value === 'number' ? cost.value : null
              }
              currencyCode={currencyCode}
              label={label}
              tooltipText={cost.description || null}
              value={displayValue}
              valueSubtitle={estimatedSubtitle}
              valueWithoutOffer={cost.valueWithoutOffer}
            />
          );
        })
      }
    </PaymentDetailsCard>
  );
};

BeforeMoveOut.propTypes = {
  costs: ListingCostsShape,
  currencyCode: PropTypes.string.isRequired,
  isCollapsed: PropTypes.bool
};

export default BeforeMoveOut;
